export function paginationSummary(page: number, pageSize: number, total: number, itemLabel: string) {
  if (total === 0) return `0 ${itemLabel}`
  const first = (page - 1) * pageSize + 1
  const last = Math.min(page * pageSize, total)
  return `${String(first)}–${String(last)} sur ${String(total)} ${itemLabel}`
}
